import { Component, Input, OnInit } from "@angular/core";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { IBackNewCoursePlanningDto } from "src/app/course-planning/interfaces/course-planning";
import { CoursePlanningService } from "src/app/course-planning/services/course-planning.service";

@Component({
  selector: "app-event-details",
  templateUrl: "./event-details.component.html",
  styleUrls: ["./event-details.component.css"],
})
export class EventDetailsComponent implements OnInit {
  public isLoading = true;
  public eventData?: IBackNewCoursePlanningDto;
  @Input() eventId: string | null = null;

  constructor(
    private coursePlanning: CoursePlanningService,
    private _authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    if (this.eventId) {
      this.loadEventDetails(this.eventId);
    }
  }

  loadEventDetails(eventId: string): void {
    this.isLoading = true;
    this.coursePlanning
      .getCoursePlanById(
        this._authService.currentUserValue.personNumber,
        eventId
      )
      .subscribe(d => {
        this.eventData = d;
        this.isLoading = false;
      });
  }

  updateEventDetails(eventId: string): void {
    this.eventId = eventId;
    this.loadEventDetails(eventId);
  }
}
